<template>
  <redmine-table :redmineUserId="redmineUserId"/>
</template>


<script>
import RedmineTable from "../components/Redmine/RedmineTable";

export default {
  components: {
    RedmineTable,
  },
  data() {
    return {
      redmineUserId:27,
      loading: false
    };
  },
  async mounted() {
    // this.loading = true;
    // try {
    //   let user = await this.getUser();
    //   //console.log(user);
    //   // eslint-disable-next-line
    //   const id = user.profile.sub;
    //   const brokerId = user.profile.brokerid;
    //   user = (
    //     await this.getApplicationUser({
    //       broker: brokerId,
    //       user: id
    //     })
    //   ).data;
    //   //console.log(this.user.RegistrationDate);
    //   this.redmineUserId = this.user.RedmineUserId;
    // } catch (error) {
    //   this.error = error;
    // }
  },
};
</script>